import { styled } from "@mui/material";
import Tabs from "../../Tabs/Tabs";

const TabsStyled = styled(Tabs)({
  marginBottom: "12px",
});

const SidebarTabs = ({
  value,
  setValue,
  tabs,
  spacing,
  classNames = { wrapper: {}, button: {}, selected: {} },
}) => {
  return (
    <TabsStyled
      setValue={setValue}
      value={value}
      tabs={tabs}
      variant="underline"
      spacing={spacing}
      classNames={classNames}
    />
  );
};

export default SidebarTabs;
